import React from "react";

const PrivacyPolicy = () => {
  return (
 
    <div class="max-w-[1280px] mx-auto p-6 leading-8">
        <div class="title">
          <h1 class="text-[42px] font-semibold py-3 text-center text-secondary">PRIVACY POLICY</h1>
          <p>
            We at HOLIDAY COMPARISON LIMITED. take privacy quite seriously. Your
            personal information is our responsibility. With your consent only
            we will contact you for different marketing promotions. It is
            extremely easy for you to opt out of any type of marketing
            promotions simply by calling, writing or emailing to us. We are
            strictly against selling any information to third parties. The
            information generally collected by us includes:
          </p>
        </div>
        <div>
          <ul className="pl-3">
            <li>
              <strong class="px-2">1</strong>
              Your name
            </li>
            <li>
              <strong class="px-2">2</strong>
              Phone number
            </li>
            <li>
              <strong class="px-2">3</strong>
              Address
            </li>
            <li>
              <strong class="px-2">4</strong>
              Email address
            </li>
            <li>
              <strong class="px-2">5</strong>
              Information on services or products purchased
            </li>
            <li>
              <strong class="px-2">6</strong>
              Debit card/Credit card details
            </li>
            <li>
              <strong class="px-2">7</strong>
              Responses to questionnaires, surveys and competitions Sensitive
              information Related to you is never collected by us without prior
              explicit consent.
            </li>
          </ul>
        </div>
        <div>
          <h2 class="text-[20px] font-medium py-3 text-secondary">
            PLEASE NOTE: WE DO NOT STORE CREDIT/DEBIT CARD DETAILS NOR DO WE
            SHARE CUSTOMER DETAILS WITH THIRD PARTIES
          </h2>
          <p>
            The information available to us will be up to date and accurate. If
            you want to recheck your information you can send us an email. In
            case of inaccuracies, we will correct or delete it as quickly as
            possible. If you want some changes in your personal information, you
            can contact us by emailing, calling or writing. Every bit of your
            personal information will be kept securely through our company's
            internal security policy as well as the law. In order to track the
            behavior pattern of the visitors to our website, we might use
            technology which includes using tracking software or cookie. Cookies
            generally get stored in your computer and the browser can be
            modified to prevent this occurrence. If the browser settings are not
            modified, information collected through this process is used for
            your identification. If the cookies are switched off, some functions
            might get restricted and in turn affect the operation of the
            website, i.e. you might not be able to access special discounts and
            promotions. The main purpose behind using tracking software is for
            recording the behavior of a consumer group rather than individuals.
            The information which gets collected cannot be used for your
            identification. In case of any comments/questions about our privacy
            policy, please Call Us.
          </p>
        </div>
</div>
  );
};

export default PrivacyPolicy;
